import { useAutoResizeTextarea as tt } from "./Hooks/useAutoResizeTextarea.js";
import { useResizeObserver as rt } from "./Hooks/useResizeObserver.js";
import { useScrollHeight as nt } from "./Hooks/useScrollHeight.js";
import { useAlertDialog as ot } from "./Hooks/useAlertDialog.js";
import { ErrorContext as at } from "./Context/ErrorContext.js";
import st from "./Components/FairPrice.js";
import { FairPriceCard as it } from "./Components/FairPriceCard.js";
import { PageWrapper as ct } from "./Components/PageWrapper.js";
import lt from "./Components/BenchmarkChart.js";
import ut from "./Components/BenchmarkSlider.js";
import { jsx as c, jsxs as y, Fragment as B } from "react/jsx-runtime";
import * as s from "react";
import { c as Z, d as L, u as de, b as D, e as dt, a as ft } from "./index-Dn5fq5RO.js";
import { P as q } from "./index-Bo0P2KXg.js";
import { PopoverMenu as pt, PopoverMenuItem as mt, PopoverMenuSeparator as vt } from "./Components/PopoverMenu.js";
import { Wrapper as gt, GreyBlock as ht, SpacerBlock as yt, Row as Et, Column as Ct } from "./Components/Skeleton.js";
import { FilterMenu as _t } from "./Components/FilterMenu.js";
import { c as fe, u as N } from "./index-BwdHfdWj.js";
import { u as H } from "./index-_igB3qdS.js";
import { r as bt } from "./index-DWGznc13.js";
import { u as Dt } from "./index-DpS21AEH.js";
import { P as pe } from "./index-C7ixzbBF.js";
import { a as At, h as St, u as Nt } from "./index-D4JPp1jr.js";
import { AlertDialogContext as Pt } from "./Components/AlertDialogContext.js";
import { Separator as Rt } from "./Components/Separator.js";
import { Badge as Ot } from "./Vivid/Badge.js";
import { c as Tt } from "./index-Cu0xwYjD.js";
import { never as me } from "./Util/never.js";
import { Button as wt } from "./Vivid/Button.js";
import { ButtonGroup as It } from "./Vivid/ButtonGroup.js";
import { C as Ft, c as xt } from "./Card-Cf3w06Qm.js";
import { CardSection as Lt, CardSectioned as Mt } from "./Vivid/CardSectioned.js";
import { Chip as kt } from "./Vivid/Chip.js";
import { FileUpload as Wt } from "./Vivid/FileUpload.js";
import { FileUploadButton as Bt } from "./Vivid/FileUploadButton.js";
import { Heading as $t } from "./Vivid/Heading.js";
import { Icon as Ut } from "./Vivid/Icon.js";
import { Pagination as Vt } from "./Vivid/Pagination.js";
import { Progress as Ht } from "./Vivid/Progress.js";
import { Spinner as jt } from "./Vivid/Spinner.js";
import Gt from "./Vivid/StarRating.js";
import { Status as Kt } from "./Vivid/Status.js";
import { Radio as zt } from "./Vivid/Radio.js";
import { Text as Yt } from "./Vivid/Text.js";
import { Link as Zt } from "./Vivid/Link.js";
import { Tooltip as qt } from "./Vivid/Tooltip.js";
import { Snackbar as Xt, SnackbarContainer as Jt } from "./Vivid/Snackbar.js";
import { Select as Qt } from "./Vivid/Select.js";
import { Slider as er } from "./Vivid/Slider.js";
import { Tabs as tr } from "./Vivid/Tabs.js";
import { VerificationCode as rr } from "./Vivid/VerificationCode.js";
import { Switch as nr } from "./Vivid/Switch.js";
import { TextInput as or } from "./Vivid/TextInput.js";
import { FormField as ar } from "./Vivid/FormField.js";
import { Textarea as sr } from "./Vivid/Textarea.js";
import { Checkbox as ir } from "./Vivid/Checkbox.js";
import "./Util/nil.js";
import "./path-DmeIXEBh.js";
import "./number-DiuiLCOa.js";
import "./index-CphWEwua.js";
import "./deliverable-DVF715F3.js";
var X = "Avatar", [cr, zo] = Z(X), [lr, ve] = cr(X), ge = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, ...n } = e, [o, a] = s.useState("idle");
    return /* @__PURE__ */ c(
      lr,
      {
        scope: r,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ c(q.span, { ...n, ref: t })
      }
    );
  }
);
ge.displayName = X;
var he = "AvatarImage", ye = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, src: n, onLoadingStatusChange: o = () => {
    }, ...a } = e, l = ve(he, r), i = ur(n, a.referrerPolicy), d = L((u) => {
      o(u), l.onImageLoadingStatusChange(u);
    });
    return de(() => {
      i !== "idle" && d(i);
    }, [i, d]), i === "loaded" ? /* @__PURE__ */ c(q.img, { ...a, ref: t, src: n }) : null;
  }
);
ye.displayName = he;
var Ee = "AvatarFallback", Ce = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, delayMs: n, ...o } = e, a = ve(Ee, r), [l, i] = s.useState(n === void 0);
    return s.useEffect(() => {
      if (n !== void 0) {
        const d = window.setTimeout(() => i(!0), n);
        return () => window.clearTimeout(d);
      }
    }, [n]), l && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ c(q.span, { ...o, ref: t }) : null;
  }
);
Ce.displayName = Ee;
function ur(e, t) {
  const [r, n] = s.useState("idle");
  return de(() => {
    if (!e) {
      n("error");
      return;
    }
    let o = !0;
    const a = new window.Image(), l = (i) => () => {
      o && n(i);
    };
    return n("loading"), a.onload = l("loaded"), a.onerror = l("error"), a.src = e, t && (a.referrerPolicy = t), () => {
      o = !1;
    };
  }, [e, t]), r;
}
var dr = ge, fr = ye, pr = Ce;
const mr = "_avatarPopoverTrigger_13ckf_1", vr = "_hamburger_13ckf_27", gr = "_avatar_13ckf_1", hr = "_avatarFallback_13ckf_52", W = {
  avatarPopoverTrigger: mr,
  hamburger: vr,
  avatar: gr,
  avatarFallback: hr
}, yr = ({
  avatarUrl: e,
  name: t,
  children: r,
  defaultOpen: n = !1,
  onOpenChange: o,
  container: a
}) => {
  const l = t == null ? void 0 : t.trim().split(" ").map((i) => i.slice(0, 1)).join("").toUpperCase();
  return /* @__PURE__ */ c(
    re.PopoverMenu,
    {
      container: a,
      defaultOpen: n,
      onOpenChange: o,
      trigger: /* @__PURE__ */ y("div", { className: W.avatarPopoverTrigger, children: [
        /* @__PURE__ */ c("div", { "aria-label": "Toggle menu", className: W.hamburger }),
        /* @__PURE__ */ y(dr, { children: [
          /* @__PURE__ */ c(
            fr,
            {
              title: t,
              className: W.avatar,
              src: e
            }
          ),
          /* @__PURE__ */ c(pr, { className: W.avatarFallback, title: t, children: /* @__PURE__ */ c(C.Text, { size: "14px", weight: "600", children: l }) })
        ] })
      ] }),
      children: r
    }
  );
}, Er = ({
  children: e,
  closeMenuOnClick: t = !1
}) => /* @__PURE__ */ c(re.PopoverMenuItem, { closeMenuOnClick: t, children: e }), Cr = () => /* @__PURE__ */ c(re.PopoverMenuSeparator, {});
var J = s.forwardRef((e, t) => {
  const { children: r, ...n } = e, o = s.Children.toArray(r), a = o.find(br);
  if (a) {
    const l = a.props.children, i = o.map((d) => d === a ? s.Children.count(l) > 1 ? s.Children.only(null) : s.isValidElement(l) ? l.props.children : null : d);
    return /* @__PURE__ */ c(K, { ...n, ref: t, children: s.isValidElement(l) ? s.cloneElement(l, void 0, i) : null });
  }
  return /* @__PURE__ */ c(K, { ...n, ref: t, children: r });
});
J.displayName = "Slot";
var K = s.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (s.isValidElement(r)) {
    const o = Ar(r), a = Dr(n, r.props);
    return r.type !== s.Fragment && (a.ref = t ? fe(t, o) : o), s.cloneElement(r, a);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
K.displayName = "SlotClone";
var _r = ({ children: e }) => /* @__PURE__ */ c(B, { children: e });
function br(e) {
  return s.isValidElement(e) && e.type === _r;
}
function Dr(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...i) => {
      a(...i), o(...i);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Ar(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Sr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], P = Sr.reduce((e, t) => {
  const r = s.forwardRef((n, o) => {
    const { asChild: a, ...l } = n, i = a ? J : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(i, { ...l, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Nr(e, t) {
  e && bt.flushSync(() => e.dispatchEvent(t));
}
var Pr = "DismissableLayer", z = "dismissableLayer.update", Rr = "dismissableLayer.pointerDownOutside", Or = "dismissableLayer.focusOutside", ae, _e = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), be = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: l,
      onDismiss: i,
      ...d
    } = e, u = s.useContext(_e), [f, O] = s.useState(null), b = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, E] = s.useState({}), U = N(t, (m) => O(m)), p = Array.from(u.layers), [T] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = p.indexOf(T), A = f ? p.indexOf(f) : -1, h = u.layersWithOutsidePointerEventsDisabled.size > 0, g = A >= v, M = Ir((m) => {
      const k = m.target, oe = [...u.branches].some((V) => V.contains(k));
      !g || oe || (o == null || o(m), l == null || l(m), m.defaultPrevented || i == null || i());
    }, b), ne = Fr((m) => {
      const k = m.target;
      [...u.branches].some((V) => V.contains(k)) || (a == null || a(m), l == null || l(m), m.defaultPrevented || i == null || i());
    }, b);
    return Dt((m) => {
      A === u.layers.size - 1 && (n == null || n(m), !m.defaultPrevented && i && (m.preventDefault(), i()));
    }, b), s.useEffect(() => {
      if (f)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (ae = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), se(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = ae);
        };
    }, [f, b, r, u]), s.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), se());
    }, [f, u]), s.useEffect(() => {
      const m = () => E({});
      return document.addEventListener(z, m), () => document.removeEventListener(z, m);
    }, []), /* @__PURE__ */ c(
      P.div,
      {
        ...d,
        ref: U,
        style: {
          pointerEvents: h ? g ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: D(e.onFocusCapture, ne.onFocusCapture),
        onBlurCapture: D(e.onBlurCapture, ne.onBlurCapture),
        onPointerDownCapture: D(
          e.onPointerDownCapture,
          M.onPointerDownCapture
        )
      }
    );
  }
);
be.displayName = Pr;
var Tr = "DismissableLayerBranch", wr = s.forwardRef((e, t) => {
  const r = s.useContext(_e), n = s.useRef(null), o = N(t, n);
  return s.useEffect(() => {
    const a = n.current;
    if (a)
      return r.branches.add(a), () => {
        r.branches.delete(a);
      };
  }, [r.branches]), /* @__PURE__ */ c(P.div, { ...e, ref: o });
});
wr.displayName = Tr;
function Ir(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = L(e), n = s.useRef(!1), o = s.useRef(() => {
  });
  return s.useEffect(() => {
    const a = (i) => {
      if (i.target && !n.current) {
        let d = function() {
          De(
            Rr,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = d, t.addEventListener("click", o.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Fr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = L(e), n = s.useRef(!1);
  return s.useEffect(() => {
    const o = (a) => {
      a.target && !n.current && De(Or, r, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function se() {
  const e = new CustomEvent(z);
  document.dispatchEvent(e);
}
function De(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? Nr(o, a) : o.dispatchEvent(a);
}
var j = "focusScope.autoFocusOnMount", G = "focusScope.autoFocusOnUnmount", ie = { bubbles: !1, cancelable: !0 }, xr = "FocusScope", Ae = s.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...l
  } = e, [i, d] = s.useState(null), u = L(o), f = L(a), O = s.useRef(null), b = N(t, (p) => d(p)), E = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (n) {
      let p = function(h) {
        if (E.paused || !i) return;
        const g = h.target;
        i.contains(g) ? O.current = g : S(O.current, { select: !0 });
      }, T = function(h) {
        if (E.paused || !i) return;
        const g = h.relatedTarget;
        g !== null && (i.contains(g) || S(O.current, { select: !0 }));
      }, v = function(h) {
        if (document.activeElement === document.body)
          for (const M of h)
            M.removedNodes.length > 0 && S(i);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", T);
      const A = new MutationObserver(v);
      return i && A.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", T), A.disconnect();
      };
    }
  }, [n, i, E.paused]), s.useEffect(() => {
    if (i) {
      le.add(E);
      const p = document.activeElement;
      if (!i.contains(p)) {
        const v = new CustomEvent(j, ie);
        i.addEventListener(j, u), i.dispatchEvent(v), v.defaultPrevented || (Lr($r(Se(i)), { select: !0 }), document.activeElement === p && S(i));
      }
      return () => {
        i.removeEventListener(j, u), setTimeout(() => {
          const v = new CustomEvent(G, ie);
          i.addEventListener(G, f), i.dispatchEvent(v), v.defaultPrevented || S(p ?? document.body, { select: !0 }), i.removeEventListener(G, f), le.remove(E);
        }, 0);
      };
    }
  }, [i, u, f, E]);
  const U = s.useCallback(
    (p) => {
      if (!r && !n || E.paused) return;
      const T = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, v = document.activeElement;
      if (T && v) {
        const A = p.currentTarget, [h, g] = Mr(A);
        h && g ? !p.shiftKey && v === g ? (p.preventDefault(), r && S(h, { select: !0 })) : p.shiftKey && v === h && (p.preventDefault(), r && S(g, { select: !0 })) : v === A && p.preventDefault();
      }
    },
    [r, n, E.paused]
  );
  return /* @__PURE__ */ c(P.div, { tabIndex: -1, ...l, ref: b, onKeyDown: U });
});
Ae.displayName = xr;
function Lr(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (S(n, { select: t }), document.activeElement !== r) return;
}
function Mr(e) {
  const t = Se(e), r = ce(t, e), n = ce(t.reverse(), e);
  return [r, n];
}
function Se(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function ce(e, t) {
  for (const r of e)
    if (!kr(r, { upTo: t })) return r;
}
function kr(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Wr(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function S(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Wr(e) && t && e.select();
  }
}
var le = Br();
function Br() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = ue(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = ue(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function ue(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function $r(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Q = "Dialog", [Ne, Pe] = Z(Q), [Ur, _] = Ne(Q), Re = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    modal: l = !0
  } = e, i = s.useRef(null), d = s.useRef(null), [u = !1, f] = ft({
    prop: n,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ c(
    Ur,
    {
      scope: t,
      triggerRef: i,
      contentRef: d,
      contentId: H(),
      titleId: H(),
      descriptionId: H(),
      open: u,
      onOpenChange: f,
      onOpenToggle: s.useCallback(() => f((O) => !O), [f]),
      modal: l,
      children: r
    }
  );
};
Re.displayName = Q;
var Oe = "DialogTrigger", Te = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = _(Oe, r), a = N(t, o.triggerRef);
    return /* @__PURE__ */ c(
      P.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": te(o.open),
        ...n,
        ref: a,
        onClick: D(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Te.displayName = Oe;
var Vr = "DialogPortal", [Yo, we] = Ne(Vr, {
  forceMount: void 0
}), $ = "DialogOverlay", Ie = s.forwardRef(
  (e, t) => {
    const r = we($, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = _($, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ c(pe, { present: n || a.open, children: /* @__PURE__ */ c(Hr, { ...o, ref: t }) }) : null;
  }
);
Ie.displayName = $;
var Hr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = _($, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ c(At, { as: J, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ c(
        P.div,
        {
          "data-state": te(o.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), w = "DialogContent", Fe = s.forwardRef(
  (e, t) => {
    const r = we(w, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = _(w, e.__scopeDialog);
    return /* @__PURE__ */ c(pe, { present: n || a.open, children: a.modal ? /* @__PURE__ */ c(jr, { ...o, ref: t }) : /* @__PURE__ */ c(Gr, { ...o, ref: t }) });
  }
);
Fe.displayName = w;
var jr = s.forwardRef(
  (e, t) => {
    const r = _(w, e.__scopeDialog), n = s.useRef(null), o = N(t, r.contentRef, n);
    return s.useEffect(() => {
      const a = n.current;
      if (a) return St(a);
    }, []), /* @__PURE__ */ c(
      xe,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: D(e.onCloseAutoFocus, (a) => {
          var l;
          a.preventDefault(), (l = r.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: D(e.onPointerDownOutside, (a) => {
          const l = a.detail.originalEvent, i = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: D(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Gr = s.forwardRef(
  (e, t) => {
    const r = _(w, e.__scopeDialog), n = s.useRef(!1), o = s.useRef(!1);
    return /* @__PURE__ */ c(
      xe,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var l, i;
          (l = e.onCloseAutoFocus) == null || l.call(e, a), a.defaultPrevented || (n.current || (i = r.triggerRef.current) == null || i.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, u;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const l = a.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(l)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), xe = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: a, ...l } = e, i = _(w, r), d = s.useRef(null), u = N(t, d);
    return Nt(), /* @__PURE__ */ y(B, { children: [
      /* @__PURE__ */ c(
        Ae,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ c(
            be,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": te(i.open),
              ...l,
              ref: u,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ y(B, { children: [
        /* @__PURE__ */ c(zr, { titleId: i.titleId }),
        /* @__PURE__ */ c(Zr, { contentRef: d, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), ee = "DialogTitle", Le = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = _(ee, r);
    return /* @__PURE__ */ c(P.h2, { id: o.titleId, ...n, ref: t });
  }
);
Le.displayName = ee;
var Me = "DialogDescription", ke = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = _(Me, r);
    return /* @__PURE__ */ c(P.p, { id: o.descriptionId, ...n, ref: t });
  }
);
ke.displayName = Me;
var We = "DialogClose", Be = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = _(We, r);
    return /* @__PURE__ */ c(
      P.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: D(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Be.displayName = We;
function te(e) {
  return e ? "open" : "closed";
}
var $e = "DialogTitleWarning", [Kr, Ue] = dt($e, {
  contentName: w,
  titleName: ee,
  docsSlug: "dialog"
}), zr = ({ titleId: e }) => {
  const t = Ue($e), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Yr = "DialogDescriptionWarning", Zr = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ue(Yr).contentName}}.`;
  return s.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, qr = Re, Xr = Te, Jr = Ie, Qr = Fe, en = Le, tn = ke, Ve = Be, rn = s.forwardRef((e, t) => {
  const { children: r, ...n } = e, o = s.Children.toArray(r), a = o.find(nn);
  if (a) {
    const l = a.props.children, i = o.map((d) => d === a ? s.Children.count(l) > 1 ? s.Children.only(null) : s.isValidElement(l) ? l.props.children : null : d);
    return /* @__PURE__ */ c(Y, { ...n, ref: t, children: s.isValidElement(l) ? s.cloneElement(l, void 0, i) : null });
  }
  return /* @__PURE__ */ c(Y, { ...n, ref: t, children: r });
});
rn.displayName = "Slot";
var Y = s.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (s.isValidElement(r)) {
    const o = an(r), a = on(n, r.props);
    return r.type !== s.Fragment && (a.ref = t ? fe(t, o) : o), s.cloneElement(r, a);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
Y.displayName = "SlotClone";
var He = ({ children: e }) => /* @__PURE__ */ c(B, { children: e });
function nn(e) {
  return s.isValidElement(e) && e.type === He;
}
function on(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...i) => {
      a(...i), o(...i);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function an(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var je = "AlertDialog", [sn, Zo] = Z(je, [
  Pe
]), R = Pe(), Ge = (e) => {
  const { __scopeAlertDialog: t, ...r } = e, n = R(t);
  return /* @__PURE__ */ c(qr, { ...n, ...r, modal: !0 });
};
Ge.displayName = je;
var cn = "AlertDialogTrigger", ln = s.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = R(r);
    return /* @__PURE__ */ c(Xr, { ...o, ...n, ref: t });
  }
);
ln.displayName = cn;
var un = "AlertDialogOverlay", Ke = s.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = R(r);
    return /* @__PURE__ */ c(Jr, { ...o, ...n, ref: t });
  }
);
Ke.displayName = un;
var x = "AlertDialogContent", [dn, fn] = sn(x), ze = s.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, children: n, ...o } = e, a = R(r), l = s.useRef(null), i = N(t, l), d = s.useRef(null);
    return /* @__PURE__ */ c(
      Kr,
      {
        contentName: x,
        titleName: Ye,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ c(dn, { scope: r, cancelRef: d, children: /* @__PURE__ */ y(
          Qr,
          {
            role: "alertdialog",
            ...a,
            ...o,
            ref: i,
            onOpenAutoFocus: D(o.onOpenAutoFocus, (u) => {
              var f;
              u.preventDefault(), (f = d.current) == null || f.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (u) => u.preventDefault(),
            onInteractOutside: (u) => u.preventDefault(),
            children: [
              /* @__PURE__ */ c(He, { children: n }),
              /* @__PURE__ */ c(mn, { contentRef: l })
            ]
          }
        ) })
      }
    );
  }
);
ze.displayName = x;
var Ye = "AlertDialogTitle", Ze = s.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = R(r);
    return /* @__PURE__ */ c(en, { ...o, ...n, ref: t });
  }
);
Ze.displayName = Ye;
var qe = "AlertDialogDescription", Xe = s.forwardRef((e, t) => {
  const { __scopeAlertDialog: r, ...n } = e, o = R(r);
  return /* @__PURE__ */ c(tn, { ...o, ...n, ref: t });
});
Xe.displayName = qe;
var pn = "AlertDialogAction", Je = s.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = R(r);
    return /* @__PURE__ */ c(Ve, { ...o, ...n, ref: t });
  }
);
Je.displayName = pn;
var Qe = "AlertDialogCancel", et = s.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, { cancelRef: o } = fn(Qe, r), a = R(r), l = N(t, o);
    return /* @__PURE__ */ c(Ve, { ...a, ...n, ref: l });
  }
);
et.displayName = Qe;
var mn = ({ contentRef: e }) => {
  const t = `\`${x}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${x}\` by passing a \`${qe}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${x}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return s.useEffect(() => {
    var n;
    document.getElementById(
      (n = e.current) == null ? void 0 : n.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, vn = Ge, gn = Ke, hn = ze, yn = Je, En = et, Cn = Ze, _n = Xe;
const bn = "_overlay_n9dax_1", Dn = "_overlayShow_n9dax_1", An = "_content_n9dax_8", Sn = "_contentShow_n9dax_1", Nn = "_container_n9dax_23", Pn = "_header_n9dax_29", Rn = "_description_n9dax_35", On = "_actions_n9dax_39", I = {
  overlay: bn,
  overlayShow: Dn,
  content: An,
  contentShow: Sn,
  container: Nn,
  header: Pn,
  description: Rn,
  actions: On
}, Tn = ({
  children: e
}) => {
  const [t, r] = s.useState(
    null
  ), [n, o] = s.useState(!1), a = s.useCallback((d) => {
    r(d), o(!0);
  }, []), l = () => {
    var d;
    o(!1), (d = t == null ? void 0 : t.onCancel) == null || d.call(t);
  }, i = () => {
    o(!1), t == null || t.onConfirm();
  };
  return /* @__PURE__ */ y(Pt.Provider, { value: { showAlert: a }, children: [
    e,
    t && /* @__PURE__ */ y(vn, { open: n, onOpenChange: o, children: [
      /* @__PURE__ */ c(
        gn,
        {
          onClick: l,
          className: I.overlay
        }
      ),
      /* @__PURE__ */ c(hn, { className: I.content, children: /* @__PURE__ */ y(C.Card, { shadow: !0, className: I.container, children: [
        /* @__PURE__ */ y("div", { className: I.header, children: [
          /* @__PURE__ */ c(Cn, { asChild: !0, children: /* @__PURE__ */ c(C.Heading, { node: "h3", children: t.title }) }),
          /* @__PURE__ */ c(_n, { asChild: !0, children: /* @__PURE__ */ c(C.Text, { size: "14px", className: I.description, children: t.description }) })
        ] }),
        /* @__PURE__ */ y("div", { className: I.actions, children: [
          /* @__PURE__ */ c(En, { asChild: !0, children: /* @__PURE__ */ c(C.Button, { buttonStyle: "secondary", onClick: l, children: t.cancelText || "Cancel" }) }),
          /* @__PURE__ */ c(yn, { asChild: !0, children: /* @__PURE__ */ c(
            C.Button,
            {
              buttonStyle: "destructive",
              onClick: i,
              children: t.actionText
            }
          ) })
        ] })
      ] }) })
    ] })
  ] });
}, wn = "_banner_vguoj_1", In = "_typeInfo_vguoj_10", Fn = "_icon_vguoj_13", xn = "_typeCaution_vguoj_18", Ln = "_typeAlert_vguoj_26", Mn = "_typeSuccess_vguoj_34", F = {
  banner: wn,
  typeInfo: In,
  icon: Fn,
  typeCaution: xn,
  typeAlert: Ln,
  typeSuccess: Mn
}, kn = (e) => {
  switch (e) {
    case "info":
      return F.typeInfo;
    case "caution":
      return F.typeCaution;
    case "alert":
      return F.typeAlert;
    case "success":
      return F.typeSuccess;
    default:
      return me(e);
  }
}, Wn = (e) => {
  switch (e) {
    case "info":
      return C.Icon.statusInfoFilled;
    case "caution":
      return C.Icon.statusCautionFilled;
    case "alert":
      return C.Icon.statusAlertFilled;
    case "success":
      return C.Icon.statusSuccessFilled;
    default:
      return me(e);
  }
}, Bn = (e) => /* @__PURE__ */ y(
  "div",
  {
    className: Tt(
      F.banner,
      kn(e.type),
      e.className
    ),
    children: [
      !e.hideIcon && /* @__PURE__ */ c("div", { className: F.icon, children: Wn(e.type) }),
      /* @__PURE__ */ c("div", { children: e.children })
    ]
  }
), C = {
  Badge: Ot,
  Banner: Bn,
  Button: wt,
  ButtonGroup: It,
  Card: Ft,
  CardSection: Lt,
  CardSectioned: Mt,
  Chip: kt,
  FileUpload: Wt,
  FileUploadButton: Bt,
  Heading: $t,
  Icon: Ut,
  Link: Zt,
  Pagination: Vt,
  Progress: Ht,
  VerificationCode: rr,
  Radio: zt,
  Select: Qt,
  Slider: er,
  Snackbar: Xt,
  SnackbarContainer: Jt,
  StarRating: Gt,
  Status: Kt,
  Spinner: jt,
  Switch: nr,
  Tabs: tr,
  Text: Yt,
  TextInput: or,
  Textarea: sr,
  FormField: ar,
  Tooltip: qt,
  Checkbox: ir,
  cardStyles: xt
}, re = {
  FairPrice: st,
  FairPriceCard: it,
  PageWrapper: ct,
  ProfileMenu: yr,
  ProfileMenuSeparator: Cr,
  ProfileMenuItem: Er,
  BenchmarkChart: lt,
  BenchmarkSlider: ut,
  PopoverMenu: pt,
  PopoverMenuItem: mt,
  PopoverMenuSeparator: vt,
  Separator: Rt,
  Skeleton: {
    Wrapper: gt,
    GreyBlock: ht,
    SpacerBlock: yt,
    Row: Et,
    Column: Ct
  },
  FilterMenu: _t,
  AlertDialogProvider: Tn
}, qo = {
  useAutoResizeTextarea: tt,
  useResizeObserver: rt,
  useScrollHeight: nt,
  useAlertDialog: ot
}, Xo = {
  ErrorContext: at
};
export {
  Tn as A,
  Bn as B,
  re as C,
  qo as H,
  yr as P,
  C as V,
  Er as a,
  Cr as b,
  Xo as c
};
